import styles from './CartLink.module.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

export const CartIcon = () => {
  const { t } = useTranslation();

  return (
    <svg
      className={styles.cartLinkIcon}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{t('cart')}</title>
      <path d="M6.02707 7.00001H8.45043C8.56666 6.99915 8.67915 7.04104 8.76649 7.11773C8.85384 7.19442 8.90994 7.30054 8.92412 7.41591L9.23864 9.05078C9.26706 9.28004 9.37826 9.49101 9.55133 9.64402M9.55133 9.64402C9.7244 9.79703 9.94742 9.88153 10.1784 9.88162H24.5798C24.8026 9.88175 25.0222 9.93426 25.221 10.0349C25.4197 10.1356 25.592 10.2816 25.724 10.4611C25.8559 10.6406 25.9438 10.8487 25.9806 11.0684C26.0173 11.2882 26.0018 11.5135 25.9354 11.7261L24.4556 16.463C24.3654 16.7522 24.1851 17.0049 23.941 17.1844C23.697 17.3638 23.4019 17.4606 23.099 17.4606H11.2376C10.9863 17.4606 10.7454 17.5604 10.5677 17.738M9.55133 9.64402L10.5677 17.738M10.5677 17.738C10.39 17.9157 10.2902 19.0645 10.2902 19.3158C10.2902 19.5671 10.39 19.808 10.5677 19.9857C10.7454 20.1634 10.9863 20.2632 11.2376 20.2632H22.6842M20.7893 25C20.4124 25 20.051 24.8503 19.7845 24.5838C19.518 24.3173 19.3683 23.9558 19.3683 23.5789C19.3683 23.2021 19.518 22.8406 19.7845 22.5741C20.051 22.3076 20.4124 22.1579 20.7893 22.1579C21.1662 22.1579 21.5277 22.3076 21.7942 22.5741C22.0607 22.8406 22.2104 23.2021 22.2104 23.5789C22.2104 23.9558 22.0607 24.3173 21.7942 24.5838C21.5277 24.8503 21.1662 25 20.7893 25ZM12.184 25C11.8071 25 11.4457 24.8503 11.1792 24.5838C10.9127 24.3173 10.763 23.9558 10.763 23.5789C10.763 23.2021 10.9127 22.8406 11.1792 22.5741C11.4457 22.3076 11.8071 22.1579 12.184 22.1579C12.5609 22.1579 12.9223 22.3076 13.1888 22.5741C13.4553 22.8406 13.6051 23.2021 13.6051 23.5789C13.6051 23.9558 13.4553 24.3173 13.1888 24.5838C12.9223 24.8503 12.5609 25 12.184 25Z" />
    </svg>
  );
};
